import { render, staticRenderFns } from "./AuthPasswordRecovery.vue?vue&type=template&id=5a5bbe8f&scoped=true&lang=pug&"
import script from "./AuthPasswordRecovery.vue?vue&type=script&lang=js&"
export * from "./AuthPasswordRecovery.vue?vue&type=script&lang=js&"
import style0 from "./AuthPasswordRecovery.vue?vue&type=style&index=0&id=5a5bbe8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5bbe8f",
  null
  
)

export default component.exports